import { useEffect } from 'react';

import { useInitializeTranslations } from '@telialt/common-cms/src/useTranslations';

import { useStickyPageActions } from '../hooks/useStickyPageActions';
import { useLiveChat } from './useLiveChat';

const ACTION_ID = 'live-chat';

type Params = {
    sessionToken?: string;
    businessPartnerId?: string;
};

export const useRegisterLiveChatAction = ({ sessionToken, businessPartnerId }: Params) => {
    const { t } = useInitializeTranslations();

    const { registerAction, removeAction, updateBadgeCountAction } = useStickyPageActions();
    const { isLoaded, isAvailable, messageCount, openLiveChat } = useLiveChat({
        sessionToken,
        businessPartnerId,
    });

    useEffect(() => {
        if (isLoaded && t) {
            registerAction({
                id: ACTION_ID,
                index: 10,
                title: isAvailable
                    ? t['sticky_page_actions.live_chat.title']
                    : t['sticky_page_actions.live_chat.title_inactive'],
                icon: isAvailable ? 'live-chat' : 'envelope',
                onClick: () => openLiveChat(),
                isVisible: true,
            });
        }

        return () => {
            removeAction(ACTION_ID);
        };
    }, [isAvailable, isLoaded, openLiveChat, registerAction, removeAction, t]);

    useEffect(() => {
        updateBadgeCountAction(ACTION_ID, messageCount);
    }, [messageCount, updateBadgeCountAction]);
};
